import anchorPolyfill from '@oddbird/css-anchor-positioning/fn'

export default function() {
    if (!("anchorName" in document.documentElement.style)) {
        anchorPolyfill()
            .then(() => {
                console.info('Loaded %c@oddbird/css-anchor-positioning', 'font-family: monospace; background-color: rgba(32, 151, 230, 0.1);')
            })
            .catch(() => {
                console.warn('Issue loading %c@oddbird/css-anchor-positioning', 'font-family: monospace; background-color: rgba(32, 151, 230, 0.1);')
            })
    }
}
